import { format } from 'date-fns/format';
import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { UnavailabilityValidation } from 'uplisting-frontend/validations';

interface IUnavailabilityAttributes {
  from: Date;
  to: Date;
  property: ModelRegistry['property'];
  multiUnit?: ModelRegistry['multi-unit'];
}

export default class UnavailabilityRepositoryService extends BaseRepositoryService<
  ModelRegistry['unavailability']
> {
  recordName = 'unavailability';
  implementMethods = ['buildChangeset', 'createRecord'];

  validation = UnavailabilityValidation;

  public createUnavailability(
    attributes: IUnavailabilityAttributes,
  ): ModelRegistry['unavailability'] {
    if (!attributes.multiUnit) {
      delete attributes.multiUnit;
    }

    return super.createRecord({
      ...attributes,
      from: format(attributes.from, 'yyyy-LL-dd'),
      to: format(attributes.to, 'yyyy-LL-dd'),
    });
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/unavailability': UnavailabilityRepositoryService;
  }
}
